import { type QuestionType } from 'types/services/Family'

function handleFinalInfoCardAdjustments(cardsInfos: QuestionType[]) {
  return cardsInfos
    .map((card: QuestionType) => {
      if (card.inconsistent === true && card.isAlert === true)
        return { ...card, isAlert: false }
      return card
    })
    .sort((x: QuestionType, y: QuestionType) => {
      if (
        (x.isAlert === true && y.isAlert === false) ||
        (x.isAlert === true && y.inconsistent === true) ||
        (x.inconsistent === true &&
          y.isAlert === false &&
          y.inconsistent === false)
      )
        return -1
      else if (
        (x.isAlert === true && y.isAlert === true) ||
        (x.inconsistent === true && y.inconsistent === true)
      )
        return 0
      else return 1
    })
}

export default handleFinalInfoCardAdjustments

// função que confirma que um card não será alerta se for inconsistente e depois ordena os alertas para primeiro
